import { logger as LOG } from '@garnish/logger';

export const telemetryLogger = LOG.extend('Telemetry');
export const telemetryEventLogger = LOG.extend('TelemetryEvent');
